import React, {useEffect, useState} from 'react';

import {FormattedProperty, getScdEventValue} from 'common/util/format-property';
import {react2panel} from 'common/util/react2panel';
import {getProjectId, getWorkspaceId} from 'common/report/util';
import {SpinnerReact} from 'common/components/spinner';
import {SpinnerSize} from 'common/components/spinner/types';
import {getLocation} from 'common/util/url';

import styles from './index.module.styl';
import {createInsightsBookmarkParams, getPropertyChangeLog} from './utils';

type HistoricalPropertyChangeLogProps = {
  property: FormattedProperty;
  dataGroupId: string;
  distinctId: string;
};

function HistoricalPropertyChangeLogReact(props: HistoricalPropertyChangeLogProps) {
  const [isLoading, setLoading] = useState<boolean>(true);
  const [propertyHistory, setPropertyHistory] = useState<Array<[string, string[]]>>([]);

  useEffect(() => {
    const bookmarkParams = createInsightsBookmarkParams({
      scdProperty: props.property,
      scdEvent: getScdEventValue(props.property),
      dataGroupId: props.dataGroupId,
      distinctId: props.distinctId,
    });
    const {pathname, search, hash} = getLocation();
    const query = async () => {
      const results = await getPropertyChangeLog({
        bookmarkParams,
        projectId: getProjectId(),
        workspaceId: getWorkspaceId(),
        location: {
          pathname,
          search,
          hash,
          key: ``,
          state: ``,
        },
      });
      setPropertyHistory(results);
      setLoading(false);
    };
    query();
  }, []);

  return (
    <div className={styles.historicalPropertyChangeLog}>
      {isLoading ? (
        <div className={styles.spinnerContainer}>
          <SpinnerReact size={SpinnerSize.Large} />
        </div>
      ) : (
        propertyHistory.map(([timestamp, segmentKeys], index) => (
          <div className={styles.changeLogContainer} key={`${index}-${timestamp}`}>
            <div className={styles.timestamp}>{timestamp}</div>
            {segmentKeys.map((segmentKey) => (
              <div className={styles.history}>{segmentKey}</div>
            ))}
          </div>
        ))
      )}
    </div>
  );
}

export const HistoricalPropertyChangeLogEl = react2panel(
  `mp-historical-property-change-log`,
  HistoricalPropertyChangeLogReact,
);
